import { makeDataObjGenerator } from 'mocks/helpers'
import { PlayingDoubleHandEnum, PlayingHandEnum } from 'types/api/enums'
import { AccountDetails } from 'types/global'
import { createGqlResponseTransformer } from 'utils/test-utils'

const defaultData: AccountDetails = {
  isSexUpdateable: true,
  isBirthDateUpdateable: true,
  isNationalityUpdateable: true,
  isNativeGivenNameUpdateable: true,
  isNativeFamilyNameUpdateable: true,
  isCountryOfResidenceUpdateable: true,
  birthDate: '2000-10-10',
  countryOfResidenceCode: 'FRA',
  nationalityCode: 'USA',
  nativeGivenName: 'Sandro10',
  nativeFamilyName: 'Testini10',
  sex: 'F',
  biographicalInformation: {
    avatarUrl: '',
    doublePlayingHand: PlayingDoubleHandEnum.FB,
    favouriteShot: '',
    heightInMeters: 1.7,
    playingHand: PlayingHandEnum.A,
    //@ts-ignore
    __typename: 'BiographicalInformation',
  },
  tennisId: 'FIL1234567',
}

export const createAccountDetails = makeDataObjGenerator(defaultData)

export const getAccountDetails = createGqlResponseTransformer(
  'accountPerson',
  'AccountPersonDetail',
  defaultData
)

export const updateAccount = createGqlResponseTransformer(
  'updateAccountPerson',
  'AccountPerson',
  defaultData
)
